export default "__VITE_ASSET__BlpLkuYb__"